<template>
  <div>
    <van-form @submit="onSubmit" @failed="onFailed" class="p-login-form" ref="loginForm"
              :show-error-message="fs">
      <!--<van-field v-if="type==='password-login'"-->
      <!--v-model="params.username"-->
      <!--type="tel"-->
      <!--name="username"-->
      <!--label="手机号/账号"-->
      <!--:rules="[{ required: true, message: '请输入账号'}]"-->
      <!--@focus="focusLabel($event)" @blur="blurLabel($event)"-->
      <!--/>-->
      <van-field class="phone" v-model="params.username"
                 type="tel"
                 name="username"
                 label="手机号"
                 :rules="[{ required: true, message: '请输入手机号'},
               {pattern, message: '请输入正确的手机号' }]"
                 @focus="focusLabel($event)" @blur="blurLabel($event)"
      />
      <van-field v-if="type==='password-login'" class="mb-23"
                 v-model="params.password"
                 type="password"
                 name="password"
                 autocomplete="off"
                 label="密码"
                 :rules="[{ required: true, message: '请输入正确的密码'}]"
                 @focus="focusLabel($event)" @blur="blurLabel($event)">
        <template #right-icon>
          <van-icon name="closed-eye" @click="passToggle($event)"/>
        </template>
      </van-field>

      <van-field class="phone-code" :class="{'mb-23': type==='code-login'}"
                 v-if="type==='code-login'||(type==='register'&& isShowCode)||type==='re-register'"
                 v-model="params.code"
                 name="code"
                 label="验证码"
                 autocomplete="off"
                 :rules="[{ required: true, message: '请输入正确的验证码'}]"
                 @focus="focusLabel($event)" @blur="blurLabel($event)">
        <template #button>
          <van-button id="TencentCaptchaBtn"
                      native-type="button" class="push-code-btn" size="small"
                      :disabled="disabled" @click="sendcode"
                      round
                      plain type="info">{{loadingCode?'获取中':btntxt}}
          </van-button>
        </template>
      </van-field>
      <van-field v-if="type==='register'||type==='re-register'"
                 v-model="params.password"
                 type="password"
                 name="password"
                 label="设置密码"
                 autocomplete="off"
                 :rules="[{ required: true,  message: '请输入密码'},
               { validator, message: '请输入6~20位密码'}]"
                 @focus="focusLabel($event)" @blur="blurLabel($event)">
        <template #right-icon>
          <van-icon name="closed-eye" @click="passToggle($event)"/>
        </template>
      </van-field>
      <van-field class="mb-23" v-if="type==='register'||type==='re-register'"
                 v-model="params.re_password"
                 type="password"
                 name="re_password"
                 label="确认密码"
                 autocomplete="off"
                 right-icon="closed-eye"
                 :rules="[{ validator: asyncValidator, message: '两次输入密码不一致' },
               { required: true,  message: '请输入确认密码'}]"
                 @focus="focusLabel($event)" @blur="blurLabel($event)">
        <template #right-icon>
          <van-icon name="closed-eye" @click="passToggle($event)"/>
        </template>
      </van-field>

      <van-field readonly class="forget mb-0 py-0" v-if="type==='password-login'||type==='code-login'">
<!--        <template #label v-if="type==='password-login'">-->
<!--          <router-link tag="div" class="forget-pass" to="/re-register">忘记密码</router-link>-->
<!--        </template>-->
<!--        <template #button>-->
<!--          <router-link class="color-base" to="/register">去注册</router-link>-->
<!--        </template>-->
      </van-field>
<!--      <van-field class="forget mb-0 py-0" v-if="type==='register'" name="isChecked"-->
<!--                 :rules="[{ required: true, message: '请您勾选服务协议'}]">-->
<!--        <template #input>-->
<!--          <van-checkbox class="agreement mr-1" v-model="params.checkbox" shape="square"-->
<!--          ></van-checkbox>-->
<!--          我已阅读并同意  <router-link :to="{name: 'XieYi', params: {id: 'static_privacy'}, query: {title: '服务协议'}}">《服务协议》</router-link>和<a href="/privacy-policy">《隐私政策》</a>-->
<!--        </template>-->
<!--      </van-field>-->
      <div class="login-submit" :class="{'mt-70':type==='re-register'}">
        <van-button v-if="type==='password-login'|| type==='code-login'" round block type="info" native-type="submit">
          登录
        </van-button>
        <van-button v-if="type==='register'||type==='re-register'" round block type="info" native-type="submit">
          {{type==='register'?'注册试用':'确定'}}
        </van-button>
      </div>
      <p class="mb-0 text-center login-p" v-if="type==='register'||type==='re-register'">
        已有账号？
        <router-link to="/login">马上登录</router-link>
      </p>
    </van-form>
    <van-popup v-model="showPop">

    </van-popup>


  </div>

</template>

<script>
  import Vue from 'vue';
  import {Button, Checkbox, Field, Form, Icon,Popup} from 'vant';

  Vue.use(Popup);
  Vue.use(Field);
  Vue.use(Button);
  Vue.use(Icon);
  Vue.use(Form);
  Vue.use(Checkbox);

  export default {
    name: "loginFormComponent",
    data() {
      return {
        showPop: false,
        // shiyong: false,
        oldType: '',
        btntxt: "获取验证码",
        disabled: false,
        time: 0,
        pattern: /^1\d{10}$/,
        params: {
          username: '',
          // phone: '',
          password: '',
          re_password: '',
          code: '',
          checkbox: false
        },
        isShowCode: true,
        fs: false,
        param: {},
        typeP: '',
        opts: {},
        loadingCode: false,
        captchaCode: {},
        idType: ''

      }
    },
    created() {
      this.typeP = this.type;
    },
    props: [
      'type'
    ],
    mounted() {
      if (sessionStorage.getItem('phone_uname')) {
        $('.phone').find('.van-field__label').addClass('inputTextFocus');
        this.isShowCode = false;
      }
    },
    methods: {
      onSubmit(values) {
        this.opts = new FormData();
        delete values.undefined;

        if (this.type === 'register') {
          let attemptCode = sessionStorage.getItem('phone_attempt_code');
          if (attemptCode) {
            this.param.attemptCode = attemptCode;
            this.param.password = values.password;
            this.registerFun(values);
          } else {
            this.opts.delete('code');
            this.opts.delete('grant_type');
            this.opts.delete('username');
            this.opts.append("username", values.username);
            this.opts.append("grant_type", 'verification_code');
            this.opts.append("code", values.code);
            this.longinFun(values);
          }

        } else if (this.type === 're-register') {
          //重置密码
          this.opts.append("password_replacement", values.password);
          this.opts.append("username", values.username);
          this.opts.append("grant_type", 'verification_code');
          this.opts.append("code", values.code);
          this.longinFun(values);

        } else {
          //密码登录和验证码登录
          this.opts.append("username", values.username);
          if (values.password) {
            this.opts.append("grant_type", 'password');
            this.opts.append("password", values.password);
          } else {
            this.opts.append("grant_type", 'verification_code');
            this.opts.append("code", values.code);
          }
          this.longinFun(values);
        }
      },

      longinFun(values) {
        this.$store.dispatch('userLogin', this.opts).then((res) => {
          if (res && res.access_token) {
            //存Token到cookie
            let names = window.location.hostname.split(".");
            if (names.length > 2) {
              names[0] = "";
            }
            let domain = names.join(".");
            this.$store.commit('SET_TOKEN', {
              name: {key: 'anqiu_education_token', value: res.access_token},
              options: {domain: domain, expires: Math.ceil(res.expires_in / 86400)}
            });
            this.$store.commit('SET_TOKEN', {
              name: {key: 'anqiu_education_refresh_token', value: res.refresh_token},
              options: {domain: domain, expires: Math.ceil(res.expires_in / 86400)}
            });
            //获取登录用户信息
            this.$store.dispatch('getCurrentUser').then(res => {
              // 将用户信息存入cookie
              this.$store.commit('SET_TOKEN', {
                name: {key: 'u_info', value: JSON.stringify(res)},
                options: {domain: domain, expires: Math.ceil(res.expires_in / 86400)}
              });
            });
            let currentUrl = localStorage.getItem('current_url')
            if (this.type === 'password-login' && currentUrl && currentUrl !== 'undefined') {
              this.$router.push(currentUrl);
            } else {
              this.$router.push('/')
            }
          } else {
            return;
          }
          //成功之后，清空表单数据
          this.params = {};
          $(this.$refs.loginForm.$el).find('.van-field__label').removeClass('inputTextFocus');


        }, (err) => {
          if (err.response.data.attemptCode) {
            sessionStorage.setItem('phone_attempt_code', err.response.data.attemptCode);
            sessionStorage.setItem('phone_uname', values.username);
            if (this.typeP === 'register') {
              let attemptCode = sessionStorage.getItem('phone_attempt_code');
              this.param.attemptCode = attemptCode;
              this.param.password = values.password;
              this.registerFun(values);
            } else {
              this.$toast('该用户尚未注册');
              this.$router.push('/register');
            }

          } else {
            this.$toast(err.response.data.consumerMessage);
          }
        })
      },
      registerFun(values) {
        this.$store.dispatch('registerUserByAttemptCode', this.param).then((res) => {
          this.$toast('注册成功');
          sessionStorage.removeItem('phone_uname');
          sessionStorage.removeItem('phone_attempt_code');
          console.log('去登录，获取Token')
          this.opts.delete('code');
          this.opts.delete('grant_type');
          this.opts.delete('username');
          this.opts.append("code", this.param.attemptCode);
          this.opts.append("grant_type", 'attempt_code');
          this.longinFun(values);
        }, err => {
          sessionStorage.removeItem('phone_uname');
          console.log(err.response.data)
        })
      },
      onFailed(errorInfo) {
        this.$toast(errorInfo.errors[0].message)
        console.log('failed', errorInfo);
      },
      //获取短信验证码
      sendcode() {
        if (this.params.username === '') {
          this.$toast("手机号不能为空");
        } else if (!this.pattern.test(this.params.username)) {
          this.$toast("手机号格式不正确");
        } else {
          this.loadingCode = true;
          let cap = new TencentCaptcha(
            document.getElementById('TencentCaptchaBtn'),
            "2075743523",
            this.callback
          );
          cap.show();
        }
      },

      // 腾讯验证码回调函数
      callback(res) {
        if (res.ret === 0) {
          const ticketParam = {};
          ticketParam.randStr = res.randstr;
          ticketParam.ticket = res.ticket;
          this.$store.dispatch('checkTicket', {params: ticketParam}).then((ticketResponse) => {
            if (ticketResponse.captchaCode === 1) {
              // 发布请求给手机发送验证码
              this.$store.dispatch('sendLoginPhoneVerificationCode', {username: this.params.username}).then(res => {
                this.$toast("请注意接收验证码");
              }).catch(function (err) {
                console.log(err);
              });
              this.loadingCode = false;
              this.time = 60;
              this.disabled = true;
              //验证码的时间设置 可有可无
              this.timer();
            }
          }, (error) => {
            this.loadingCode = false;
          }, () => {
            this.loadingCode = false;
          });
        }
        if (res.ret === 2) {
          this.loadingCode = false;
          console.log('用户自己关闭了验证码');
        }


      },
      //验证码的倒计时
      timer() {
        if (this.time > 0) {
          this.time--;
          this.btntxt = this.time + "s后获取";
          setTimeout(this.timer, 1000);
        } else {
          this.time = 0;
          this.btntxt = "获取验证码";
          this.disabled = false;
        }
      },
      //密码可见隐藏
      passToggle(e) {
        let control = $(e.target).parents('.van-cell').find('.van-field__control');
        let ty = control.attr('type');
        if (ty === 'password') {
          control.attr('type', 'text');
          $(e.target).removeClass('van-icon-closed-eye');
          $(e.target).addClass('van-icon-eye-o');
        } else {
          control.attr('type', 'password');
          $(e.target).removeClass('van-icon-eye-o');
          $(e.target).addClass('van-icon-closed-eye');
        }
      },
      focusLabel(e) {
        $(e.target).parents('.van-cell').find('.van-field__label').addClass('inputTextFocus');
        $(e.target).parents('.van-cell').css('border-bottom', '1px solid #2424ff');
      },
      blurLabel(e) {
        if ($(e.target).val() === '') {
          $(e.target).parents('.van-cell').find('.van-field__label').removeClass('inputTextFocus');
        } else {
          if (sessionStorage.getItem('phone_uname')) {
            if ($(e.target).attr('name') === 'username' &&
              $(e.target).val() !== sessionStorage.getItem('phone_uname')) {
              this.isShowCode = true;
            } else {
              this.isShowCode = false;
            }
          } else {
            this.isShowCode = true;
          }


        }
        $(e.target).parents('.van-cell').css('border-bottom', '0');
      },
      validator(val) {
        return val.length >= 6 && val.length <= 20;
      },
      // 异步校验函数返回 Promise
      asyncValidator(val) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(this.params.password === this.params.re_password);
          }, 10);
        });
      },
    }

  }
</script>

<style>

</style>
